/**
 * Label - shadcn/ui form label, Novala-styled.
 * Small font, medium weight, sub color.
 */

import * as React from "react";
import { cn } from "../../lib/utils";

const Label = React.forwardRef<HTMLLabelElement, React.LabelHTMLAttributes<HTMLLabelElement>>(({ className, ...props }, ref) => (
  <label ref={ref} className={cn("text-small font-medium text-sub leading-none mb-2 block peer-disabled:cursor-not-allowed peer-disabled:opacity-70", className)} {...props} />
));
Label.displayName = "Label";

export { Label };
